

export default function scrollDownOnClick() {
    jQuery(document).on('click', '#ume-scroll-down', function (event) {
        event.preventDefault();
        const topScroller = document.querySelector('.main-area__top');
        const coverBlock = topScroller?.nextElementSibling;
        const isReduced = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;

        if (!!isReduced) {
            if(coverBlock instanceof HTMLElement && coverBlock.classList.contains('wp-block-cover')) {
                let newTopValue = coverBlock.offsetHeight;
                window.scrollTo({
                    top: newTopValue,
                    behavior: 'instant'
                });
            }else{
                let viewportHeight = jQuery(window).height();
                window.scrollTo({
                    top: viewportHeight,
                    behavior: 'instant'
                });
            }
        } else {
            if(coverBlock instanceof HTMLElement && coverBlock.classList.contains('wp-block-cover')) {
                let newTopValue = coverBlock.offsetHeight;
                window.scrollTo({
                    top: newTopValue,
                    behavior: 'smooth'
                });
            }else{
                let viewportHeight = jQuery(window).height();
                window.scrollTo({
                    top: viewportHeight,
                    behavior: 'smooth'
                });
            }
        }


    });
}
